const jobFilter = () => {
  const baseClass = 'kirinus-job-openings-overview-filter__wrapper';
  const jobFilterWrapper = document.querySelector('.kirinus-job-openings-overview-filter__wrapper');

  if(document.querySelector('.kirinus-job-openings-overview-filter__wrapper')) {
    const jobFilterElements = jobFilterWrapper.querySelectorAll('.btn');
    const countJobs = document.querySelectorAll('.kirinus-job-openings-overview-list-entry').length;

    document.addEventListener('click', ev =>{
      if(!ev.target.classList.contains('kirinus-job-openings-overview-filter__title')) return;
      ev.preventDefault();
      const parent = ev.target.closest('.kirinus-job-openings-overview-filter__title');
      parent.classList.toggle('is-active');

      let txt = ev.target.querySelector('span').innerText;
      ev.target.querySelector('span').innerText = txt === '-' ? '+' : '-';
    })

    // document.querySelector('.kirinus-job-openings-overview-filter__wrapper-count-complete').innerHTML = `(${countJobs})`;
    for (let x of jobFilterElements) {
      if (!x.classList.contains('btn-primary')) {
        x.addEventListener("click", function(e) {
          if (e.target.classList.contains('is-active')) {
            for (let x of jobFilterElements) {
              x.classList.remove('is-active');
            }

            if (e.target.nextElementSibling.querySelectorAll('input:checked').length >= 1) {
              e.target.classList.add('is-selected');
              document.querySelector('.btn-reset').classList.add('btn-normal');
            } else {
              e.target.classList.remove('is-selected');
              document.querySelector('.btn-reset').classList.remove('btn-normal');
            }

          } else {
            for (let x of jobFilterElements) {
              x.classList.remove('is-active');
            }

            e.target.classList.add('is-active');
          }
        })
      }
    }

    document.addEventListener("click", function(e) {
      if (e.target.closest(`.${baseClass}`)) {
        return;
      }

      Array.from(document.querySelectorAll(`.${baseClass} .btn`)).map(item => {
        item.classList.remove('is-active');
      });
    });
  }
}
export default jobFilter;